import Axios from 'axios';
import config from '../config/dev';
import User from '../helpers/user';

//
// REQUEST INTERCEPTOR
//
Axios.interceptors.request.use(
    function (requestConfig) {
        document.body.classList.add('loading-body');

        // Auth header (ha van user)
        if (!User.isGuest()) {
            requestConfig.headers.Authorization = User.getUser().auth_key;
        }

        // 🔥 Xdebug trigger CSAK dev környezetben
        if (process.env.NODE_ENV === 'development') {
            requestConfig.headers['XDEBUG_TRIGGER'] = '1';
        }

        return requestConfig;
    },
    function (error) {
        document.body.classList.remove('loading-body');
        return Promise.reject(error);
    });

//
// RESPONSE INTERCEPTOR
//
Axios.interceptors.response.use(function (response) {
    document.body.classList.remove('loading-body');

    return response;
}, function (error) {
    document.body.classList.remove('loading-body');

    console.log(error);

    // Network/DNS/CORS/timeout esetén nincs error.response
    const status = error && error.response ? error.response.status : undefined;

    if (status === 401) {
        User.logout();
        return Promise.reject(error);
    }

        // 422 megy tovább (form validation)
    if (status !== 422) {
        alert(
            "Váratlan hiba történt! Kérjük frissítse a böngészőt.\n" +
            "Ha a hiba továbbra is fennáll, kérjük vegye fel a kapcsolatot az üzemeltetőkkel!"
        );

        try {
            api.report(error);
        } catch (e) {
            console.log('Error reporting failed:', e);
        }

        return Promise.reject(error);
    }

    return Promise.reject(error);
});

//
// API WRAPPER
//
const api = {

    get(url, params = {}) {
        return Axios.get(config.ENDPOINT_BASE_URL + url, { params });
    },

    post(url, data) {
        return Axios.post(config.ENDPOINT_BASE_URL + url, data);
    },

    postFile(url, data) {
        return Axios.post(config.ENDPOINT_BASE_URL + url, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    put(url, data) {
        return Axios.put(config.ENDPOINT_BASE_URL + url, data);
    },

    delete(url) {
        return Axios.delete(config.ENDPOINT_BASE_URL + url);
    },

    report(error) {
        const enabled = String(process.env.REACT_APP_SLACK_REPORT_ENABLED).toLowerCase() === 'true';
        const webhookUrl = process.env.REACT_APP_SLACK_REPORT_WEBHOOK_URL;

        if (!enabled) {
            console.log('Slack report is not enabled!');
            return;
        }

        if (!webhookUrl) {
            console.log('Slack webhook URL is missing!');
            return;
        }

        const payload = {
            text: typeof error === 'string' ? error : JSON.stringify(error, null, 2),
        };

        return Axios.post(webhookUrl, payload, {
            withCredentials: false,
        });
    },
    downloadFile(url, name) {
        window.open(
            config.ENDPOINT_BASE_URL +
            url +
            '?api_token=' +
            encodeURIComponent(User.requireUser().auth_key) +
            '&name=' +
            encodeURIComponent(name)
        );
    },
};

export default api;



// WEBPACK FOOTER //
// ./src/source/api.js